<script setup lang="ts">
import ToggleSwitch from 'primevue/toggleswitch'

interface Props {
  /** Disable user interaction. */
  disabled?: boolean
}

defineProps<Props>()

const model = defineModel<boolean>()
</script>

<template>
  <ToggleSwitch v-model="model" :disabled="disabled" />
</template>
